<template>
    <div class="grid col-gap-2 tw-mt-8 tw-mb-6">
        <div class="quiz-true-false-btn tw-border-green-500  tw-bg-green-400" :class="{'tw-opacity-50': answer.value && answer.value !== '1'}" @click="setQuestionAnswer(1)">
            <i class="fa fa-check tw-pr-3"></i>
            <p>{{ translations['quiz.true'] }}</p>
        </div>
        <div class="quiz-true-false-btn tw-border-red-500 tw-bg-red-400" :class="{'tw-opacity-50': answer.value && answer.value !== '0'}" @click="setQuestionAnswer(0)">
            <i class="fa fa-times tw-pr-3"></i>
            <p>{{ translations['quiz.false'] }}</p>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Global from '../../../mixins/Global.js';

    export default {
        mixins: [Global],
        name: "TrueFalse",

        props: ['question'],

        computed: {
            ...mapState('quiz',
                ['new_answer']
            ),

            answer: {
                get() {
                    let answer = this.$store.getters['quiz/getQuestionProgress'](this.question.id);

                    if(typeof answer !== "undefined") {
                        return answer;
                    }

                    return this.new_answer;
                },

                set(value) {
                    let answer = this.$store.getters['quiz/getQuestionProgress'](this.question.id);

                    if(typeof answer !== "undefined") {
                        answer.value = value;
                    } else {
                        this.$store.commit('quiz/setNewAnswer', {value: value, type: this.question.type});
                        this.$forceUpdate();
                    }

					this.$store.commit('quiz/setCurrentAnswer', value);
                }
            }
        },

        data() {
            return {
                question_answer: [],
                answers:[],
            }
        },

        methods: {
            // new:
            setQuestionAnswer(option) {
                this.$store.commit('quiz/removeAnswerConfirmation');

                this.answer = option.toString();
            }
        }

    }
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        .grid {
            grid-template-columns: 150px 150px;
        }

        .quiz-true-false-btn {
            @apply tw-flex tw-border-2 tw-p-4 tw-items-center tw-justify-center tw-text-white tw-rounded-lg tw-font-semibold tw-cursor-pointer;
            transition: transform 0.2s;

            &:hover {
                @apply tw-opacity-75;
            }

            &:active {
                transform: scale(0.97) translateY(-1px);
            }
        }
    }
</style>